module.exports = "https://cdn.littlereply.com/tt/resource/feed_limited.9ad9cdff59e3e34ae0a945201351a3b5.png";